import { render, staticRenderFns } from "./transaction-in.vue?vue&type=template&id=e60c3520"
import script from "./transaction-in.js?vue&type=script&lang=js&external"
export * from "./transaction-in.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports